<mat-card class="float-card">
	<p>
		You are unsubscribed!
	</p>
</mat-card>
